const templates = [
  {
    id: "wishlist-link",
    data: "wishlist",
    template: `
      <a href="{{ wishlist.url }}" class="wk-link wk-link--{{ wishlist.state }}" title="{{ locale.view_wishlist }}">
        <div class="wk-icon wk-link__icon">{% include "wishlist-icon-header" %}</div>
        <span class="wk-link__label">{{ locale.wishlist }}</span>
        <span class="wk-link__count">{{ wishlist.item_count }}</span>
      </a>
    `,
  },
  {
    id: "wishlist-button",
    data: "product",
    events: {
      "click button[data-wk-add-product]": (event) => {
        event.preventDefault();
        event.stopPropagation();

        const select = document.querySelector("form select[name='id']");
        WishlistKing.toolkit.addProduct(
          event.currentTarget.getAttribute("data-wk-add-product"),
          select ? select.value : undefined
        );
      },
      "click button[data-wk-remove-product]": (event) => {
        event.preventDefault();
        event.stopPropagation();

        WishlistKing.toolkit.removeProduct(
          event.currentTarget.getAttribute("data-wk-remove-product")
        );
      },
      "click button[data-wk-remove-item]": (event) => {
        event.preventDefault();
        event.stopPropagation();

        WishlistKing.toolkit.removeItem(
          event.currentTarget.getAttribute("data-wk-remove-item")
        );
      },
    },
    template: `
      {% if product.in_wishlist %}
        {% assign btn_text = locale.in_wishlist %}
        {% assign btn_title = locale.remove_from_wishlist %}
        {% assign btn_action = 'remove' %}
      {% else %}
        {% assign btn_text = locale.add_to_wishlist %}
        {% assign btn_title = locale.add_to_wishlist %}
        {% assign btn_action = 'add' %}
      {% endif %}

      {% assign scope = "product" %}
      {% assign targetId = product.id %}
      {% assign icon_name = "wishlist-icon" %}

      {% if itemId %}
      {% assign scope = "item" %}
      {% assign targetId = itemId %}
      {% assign icon_name = "remove-icon" %}
      {% endif %}

      <button type="button" class="wk-button wk-button--{{ btn_action }} {{ addClass }}" title="{{ btn_title }}" data-wk-{{ btn_action }}-{{ scope }}="{{ targetId }}">
        <div class="wk-icon wk-button__icon">{% include icon_name %}</div>
        <span class="wk-button__label">{{ btn_text }}</span>
      </button>
    `,
  },
  {
    id: "wishlist-button-floating",
    data: "product",
    template: `
      {% include "wishlist-button" addClass: "wk-button--floating" %}
    `,
  },
  /*
  {
    id: "wishlist-list",
    data: "wishlist",
    template: `      
      {% if wishlist.item_count == 0 %}
      {% else %}
		<div class="menu-drawer-whishlist__box">
          {% assign item_count = 0 %}
          {% assign limit = 4 %}          
          {% assign products = wishlist.products | reverse %}
          {% for product in products %}
            {% assign item_count = item_count | plus: 1 %}
            {% unless limit and item_count > limit %}
                            
              <div class='menu-drawer-whishlist__item'>               
                <a href="{{ product | variant_url }}" class="wk-product-image" title="{{ locale.view_product }}" style="background-image: url({{ product | variant_img_url: '150x' }})"></a>	
              </div>
            {% endunless %}
          {% endfor %}
        </div>
      {% endif %}
   
    `,
  },
  */
  {
    id: "search-modal__whishlist",
    data: "wishlist",
    template: `      
      {% if wishlist.item_count == 0 %}
      {% else %}

      <div class="search-modal__whishlist">
		<div class="search-modal__title search-modal__title--with-link">お気に入りアイテム<a href="/pages/wishlist" class="link underlined-link">すべて見る</a></div>
		<div class="search-modal__whishlist__box">
          {% assign item_count = 0 %}
          {% assign limit = 5 %}          
          {% assign products = wishlist.products | reverse %}
          {% for product in products %}
            {% assign item_count = item_count | plus: 1 %}
            {% unless limit and item_count > limit %}
                            
              <div class='search-modal__whishlist__item'>               
                <a href="{{ product | variant_url }}" class="wk-product-image" title="{{ locale.view_product }}" style="background-image: url({{ product | variant_img_url: '300x' }})"></a>	
              </div>
            {% endunless %}
          {% endfor %}
        </div>
	  </div>
      {% endif %}
   
    `,
  },
  {
    id: "wishlist-page",
    data: "wishlist",
    events: {
      "click a[data-wk-share]": (event) => {
        event.preventDefault();
        event.stopPropagation();

        WishlistKing.toolkit.requestWishlistSharing({
          wkShareService: event.currentTarget.getAttribute(
            "data-wk-share-service"
          ),
          wkShare: event.currentTarget.getAttribute("data-wk-share"),
          wkShareImage: event.currentTarget.getAttribute("data-wk-share-image"),
        });
      },
    },
    template: `
      <div class='wk-page'>
      {% if wishlist.item_count == 0 %}

          <div class="wk-note wk-note__list-empty">
            <p>{{ locale.wishlist_empty_note }}</p>
          </div>

      {% else %}

{% comment %}
        {% if customer_accounts_enabled and customer == null and wishlist.read_only == false %}
          <div class="wk-note wk-note__login">
            <p>{{ locale.login_or_signup_note }}</p>
          </div>
        {% endif %}
{% endcomment %}

        <div class="wk-grid">
          {% assign item_count = 0 %}
          {% assign products = wishlist.products | reverse %}
          {% for product in products %}
            {% assign item_count = item_count | plus: 1 %}
            {% unless limit and item_count > limit %}
              {% assign hide_default_title = false %}
              {% if product.variants.length == 1 and product.variants[0].title contains 'Default' %}
                {% assign hide_default_title = true %}
              {% endif %}

              {% assign variant = product.selected_or_first_available_variant %}
              {% if variant.price < variant.compare_at_price %}
                {% assign onsale = true %}
              {% else %}
                {% assign onsale = false %}
              {% endif %}

              <div class="wk-grid__item {% if onsale %}wk-product--sale{% endif %}" data-wk-item="{{ product.wishlist_item_id }}">
                {% unless wishlist.read_only %}
                  {% include "wishlist-button-floating" itemId: product.wishlist_item_id %}
                {% else %}
                  {% include "wishlist-button-floating" product: product %}
                {% endunless %}

                <a href="{{ product | variant_url }}" class="wk-product-image" title="{{ locale.view_product }}" style="background-image: url({{ product | img_url: '400x' }})"></a>

                <div class="wk-product-info">
                  <a class="wk-product-title" href="{{ product | variant_url }}">
                    {{ product.title }}
                  </a>
                  <div class="wk-product-price">
                    <span class="wk-product-price--current">{{ variant.price | money }}</span>
                    <span class="wk-product-price--compare">{{ variant.compare_at_price | money }}</span>
                    <small>(税込)</small>
                  </div>
                </div>

				<!--
       <div class="wk-product-vendor">        
        <div class="wk-product-vendor__txt">
          <div class="wk-product-vendor__label">
            SELECTED BY
          </div>
          <div class="wk-product-vendor__name">            
          	{{ product.vendor }}
          </div>                              
        </div>        
      </div>
-->


                {% include "wishlist-product-form" %}
              </div>
            {% endunless %}
          {% endfor %}
        </div>

        {% comment %}
        {% unless wishlist.read_only %}
          {% include "wishlist-button-clear" %}
        {% endunless %}
        {% endcomment %}

        {% comment %}
        {% include "wishlist-button-bulk-add-to-cart" %}
        {% endcomment %}

        {% unless wishlist.read_only %}
          <div class="wk-sharing">
            <h4 class="wk-title">{{ locale.share_wishlist }}</h4>
            <ul class="wk-sharing__list">
              {% comment %}<li class="wk-sharing__list-item">{% include "wishlist-share-button-fb" %}</li>{% endcomment %}
              {% comment %}<li class="wk-sharing__list-item">{% include "wishlist-share-button-twitter" %}</li>{% endcomment %}
              {% comment %}
              <li class="wk-sharing__list-item">
              <a href="#" class="wk-share-button" title="メールアドレスでシェアする" data-wk-share-service="email" data-wk-share="{{ wishlist.permaId }}">
              <svg xmlns="http://www.w3.org/2000/svg" width="233.511" height="233.512" viewBox="0 0 233.511 233.512" style="width:30px;height:30px;"><g id="グループ_9" data-name="グループ 9" transform="translate(-374.984 -405.404)"><path id="パス_48" data-name="パス 48" d="M578.324,638.916H405.157a30.172,30.172,0,0,1-30.173-30.171V435.575A30.172,30.172,0,0,1,405.157,405.4H578.324a30.172,30.172,0,0,1,30.171,30.171v173.17a30.172,30.172,0,0,1-30.171,30.171" fill="red"/><g id="グループ_5" data-name="グループ 5"><path id="パス_49" data-name="パス 49" d="M473.047,595.314a14.531,14.531,0,0,0,17.3,8.8l4.265-1.137a6.034,6.034,0,0,0,3.446-9.2l-27.777-41.066c-4.085,1.077-8.267,2.012-12.449,3.214Z" fill="#fff"/><path id="パス_50" data-name="パス 50" d="M569.419,545.046l-11.591-39.44-11.592-39.441a4.734,4.734,0,0,0-7.893-2.012q-.551.549-1.105,1.089c-3.426,3.412-6.92,6.649-10.517,9.729a189.737,189.737,0,0,1-27.5,19.754,32.057,32.057,0,0,0,1.836-6.068,44.123,44.123,0,0,0-21.966-45.545c-8.04-4.138-16.4-4.517-23.537-1.07a24.774,24.774,0,0,0-12.213,13.619c-7.374.269-14.09,3.05-18.7,8.419-10.314,12.006-6.294,32.433,8.961,45.538a44.681,44.681,0,0,0,12.871,7.784c-.993.307-1.995.611-3,.905a8.871,8.871,0,0,0-6.013,11l1.02,3.476-24.614,15.138,28.891-.589,1.023,3.477a8.867,8.867,0,0,0,11,5.992q1.538-.449,3.073-.877l-5.664-19.268-5.649-19.218a37.708,37.708,0,0,0,13.535,2.631c.2,0,.406-.01.611-.015l3.815,12.983,5.784,19.677c2.541-.6,5.045-1.162,7.534-1.666l-5.931-20.183-3.509-11.938a23.822,23.822,0,0,0,11.313-7.01l4.506,15.332,6.322,21.51q3.889-.6,7.721-1.043l-6.654-22.639-5.005-17.031c.217-.1.436-.192.653-.3a23.855,23.855,0,0,0,9.963-9.081l6.7,22.789,7.389,25.141a190.277,190.277,0,0,1,36.955,1.6c4.691.646,9.379,1.479,14.107,2.494.5.1,1.013.209,1.522.319a4.734,4.734,0,0,0,5.546-5.963m-96.79-39.735c-6.838,7.956-21.517,6.6-32.727-3.03s-14.763-23.938-7.925-31.9,21.517-6.6,32.724,3.03a32.378,32.378,0,0,1,10.839,17.24c1.264,5.8.229,11-2.911,14.656m18.939-18.547a17.791,17.791,0,0,1-5.9,10.58,31.02,31.02,0,0,0-.676-8.749,42.1,42.1,0,0,0-13.988-22.52,43.751,43.751,0,0,0-17.517-9.274,14.521,14.521,0,0,1,6.267-6.046c4.342-2.092,9.634-1.753,14.908.961a34.484,34.484,0,0,1,16.9,35.048" fill="#fff"/></g></g></svg>
              </a>              
              </li>
              {% endcomment %}
              {% comment %}<li class="wk-sharing__list-item">{% include "wishlist-share-button-email" %}</li>{% endcomment %}
              <li class="wk-sharing__list-item">
              <a href="#" class="wk-share-button" title="リンクを取得" data-wk-share-service="link" data-wk-share="{{ wishlist.permaId }}">
                <svg xmlns="http://www.w3.org/2000/svg" width="233.511" height="233.512" viewBox="0 0 233.511 233.512" style="width:30px;height:30px;"><g id="グループ_9" data-name="グループ 9" transform="translate(-374.984 -405.404)"><path id="パス_48" data-name="パス 48" d="M578.324,638.916H405.157a30.172,30.172,0,0,1-30.173-30.171V435.575A30.172,30.172,0,0,1,405.157,405.4H578.324a30.172,30.172,0,0,1,30.171,30.171v173.17a30.172,30.172,0,0,1-30.171,30.171" fill="red"/><g id="グループ_5" data-name="グループ 5"><path id="パス_49" data-name="パス 49" d="M473.047,595.314a14.531,14.531,0,0,0,17.3,8.8l4.265-1.137a6.034,6.034,0,0,0,3.446-9.2l-27.777-41.066c-4.085,1.077-8.267,2.012-12.449,3.214Z" fill="#fff"/><path id="パス_50" data-name="パス 50" d="M569.419,545.046l-11.591-39.44-11.592-39.441a4.734,4.734,0,0,0-7.893-2.012q-.551.549-1.105,1.089c-3.426,3.412-6.92,6.649-10.517,9.729a189.737,189.737,0,0,1-27.5,19.754,32.057,32.057,0,0,0,1.836-6.068,44.123,44.123,0,0,0-21.966-45.545c-8.04-4.138-16.4-4.517-23.537-1.07a24.774,24.774,0,0,0-12.213,13.619c-7.374.269-14.09,3.05-18.7,8.419-10.314,12.006-6.294,32.433,8.961,45.538a44.681,44.681,0,0,0,12.871,7.784c-.993.307-1.995.611-3,.905a8.871,8.871,0,0,0-6.013,11l1.02,3.476-24.614,15.138,28.891-.589,1.023,3.477a8.867,8.867,0,0,0,11,5.992q1.538-.449,3.073-.877l-5.664-19.268-5.649-19.218a37.708,37.708,0,0,0,13.535,2.631c.2,0,.406-.01.611-.015l3.815,12.983,5.784,19.677c2.541-.6,5.045-1.162,7.534-1.666l-5.931-20.183-3.509-11.938a23.822,23.822,0,0,0,11.313-7.01l4.506,15.332,6.322,21.51q3.889-.6,7.721-1.043l-6.654-22.639-5.005-17.031c.217-.1.436-.192.653-.3a23.855,23.855,0,0,0,9.963-9.081l6.7,22.789,7.389,25.141a190.277,190.277,0,0,1,36.955,1.6c4.691.646,9.379,1.479,14.107,2.494.5.1,1.013.209,1.522.319a4.734,4.734,0,0,0,5.546-5.963m-96.79-39.735c-6.838,7.956-21.517,6.6-32.727-3.03s-14.763-23.938-7.925-31.9,21.517-6.6,32.724,3.03a32.378,32.378,0,0,1,10.839,17.24c1.264,5.8.229,11-2.911,14.656m18.939-18.547a17.791,17.791,0,0,1-5.9,10.58,31.02,31.02,0,0,0-.676-8.749,42.1,42.1,0,0,0-13.988-22.52,43.751,43.751,0,0,0-17.517-9.274,14.521,14.521,0,0,1,6.267-6.046c4.342-2.092,9.634-1.753,14.908.961a34.484,34.484,0,0,1,16.9,35.048" fill="#fff"/></g></g></svg>
              </a>
              </li>
              {% comment %}<li class="wk-sharing__list-item">{% include "wishlist-share-button-link" %}</li>{% endcomment %}
              {% comment %}<li class="wk-sharing__list-item"><a href="https://social-plugins.line.me/lineit/share?url=https://hatch-hatchj8.myshopify.com/pages/shared-wishlist/{{ wishlist.permaId }}" class="wk-share-button"><svg xmlns="http://www.w3.org/2000/svg" width="29.627" height="29.627" viewBox="0 0 29.627 29.627"><g transform="translate(-172.708 -661.121)"><rect width="29.627" height="29.627" rx="4.594" transform="translate(172.708 661.121)" fill="#00b700"/><path d="M195.907,675c0-3.752-3.762-6.8-8.386-6.8s-8.385,3.053-8.385,6.8c0,3.364,2.983,6.181,7.013,6.713.273.059.645.181.739.414a1.733,1.733,0,0,1,.027.758s-.1.592-.12.718c-.036.212-.168.829.726.452a27.039,27.039,0,0,0,6.589-4.868h0a6.052,6.052,0,0,0,1.8-4.187" fill="#fff"/><path d="M185.757,673.19h-.588a.163.163,0,0,0-.163.163v3.654a.163.163,0,0,0,.163.163h.588a.164.164,0,0,0,.164-.163v-3.654a.164.164,0,0,0-.164-.163" fill="#00b700"/><path d="M189.806,673.19h-.589a.163.163,0,0,0-.163.163v2.171l-1.674-2.262-.013-.016h0l-.01-.01,0,0-.009-.007,0,0-.008-.005-.005,0-.009-.005,0,0-.01,0,0,0-.009,0h-.006l-.01,0h-.617a.164.164,0,0,0-.164.163v3.654a.164.164,0,0,0,.164.163h.588a.163.163,0,0,0,.163-.163v-2.17l1.677,2.264a.156.156,0,0,0,.041.04h0l.01.006,0,0,.008,0,.008,0,.005,0,.011,0h0a.139.139,0,0,0,.041.006h.589a.163.163,0,0,0,.163-.163v-3.654a.163.163,0,0,0-.163-.163" fill="#00b700"/><path d="M184.339,676.255h-1.6v-2.9a.163.163,0,0,0-.163-.163h-.588a.164.164,0,0,0-.164.163v3.653h0a.162.162,0,0,0,.046.112l0,0,0,0a.163.163,0,0,0,.113.046h2.349a.163.163,0,0,0,.163-.164v-.588a.162.162,0,0,0-.163-.163" fill="#00b700"/><path d="M193.054,674.1a.163.163,0,0,0,.163-.164v-.588a.163.163,0,0,0-.163-.163H190.7a.163.163,0,0,0-.114.046v0l0,0a.16.16,0,0,0-.045.112h0v3.653h0a.162.162,0,0,0,.045.112l0,0,0,0a.163.163,0,0,0,.113.046h2.35a.164.164,0,0,0,.163-.164v-.588a.163.163,0,0,0-.163-.163h-1.6v-.618h1.6a.163.163,0,0,0,.163-.163v-.588a.163.163,0,0,0-.163-.164h-1.6V674.1Z" fill="#00b700"/></g></svg></a></li>{% endcomment %}
              {% comment %}<li class="wk-sharing__list-item">{% include "wishlist-share-button-whatsapp" %}</li>{% endcomment %}
              {% comment %}<li class="wk-sharing__list-item">{% include "wishlist-share-button-contact" %}</li>{% endcomment %}
            </ul>
            <div class="wk-sharing__link wk-sharing__link--hidden"><span class="wk-sharing__link-text"></span><button class="wk-sharing__link__copy-button" data-clipboard-target=".wk-sharing__link-text">{{ locale.copy_share_link }}</button></div>
          </div>
        {% endunless %}
      {% endif %}
      </div>
    `,
  },
  {
    id: "wishlist-product-form",
    events: {
      "render .wk-product-form": (form) => {
        const container = form.closest("[data-wk-item]");
        const itemId = container.getAttribute("data-wk-item");
        WishlistKing.toolkit.getItem(itemId).then((product) => {
          WishlistKing.toolkit.initProductForm(form, product, {
            // NOTE: Uncomment to override default option change
            // onOptionChange: (event) => {
            //   console.log(event.dataset);
            // },
            // NOTE: Uncomment to override default form submit
            // onFormSubmit: (event) => {
            //   event.preventDefault();
            //   event.stopPropagation();
            // },
          });
        });
      },
    },
    template: `
<!--
      <form class="wk-product-form" action="/cart/add" method="post">
        {% assign current_variant = product.selected_or_first_available_variant %}
        <div class="wk-product-form__options">
          <input name="id" value="{{ current_variant.id }}" type="hidden">
          {% unless product.has_only_default_variant %}
            {% for option in product.options_with_values %}
              <div class="wk-product-form__option">
                <label class="wk-product-form__option__label" for="Option{{ option.position }}">
                  {{ option.name }}
                </label>
                <select class="wk-product-form__option__select" name="options[{{ option.name | escape }}]">
                  {% for value in option.values %}
                    <option value="{{ value | escape }}" {% if option.selected_value == value %}selected="selected"{% endif %} {% if option.soldout_values contains value %}disabled{% endif %}>
                      {{ value }}
                    </option>
                  {% endfor %}
                </select>
              </div>
            {% endfor %}
          {% endunless %}
          {% comment %}
          <div class="wk-product-form__quantity">
            <label class="wk-product-form__quantity__label" for="Quantity">{{ locale.quantity }}</label>
            <input class="wk-product-form__quantity__input" type="number" name="quantity" value="1" min="1">
          </div>
          {% endcomment %}
        </div>
        <button type="submit" class="wk-product-form__submit" data-wk-add-to-cart="{{ product.wishlist_item_id }}" {% unless current_variant.available %}disabled{% endunless %}>
          {% if current_variant.available %}{{ locale.add_to_cart }}{% else %}{{ locale.sold_out }}{% endif %}
        </button>
      </form>
-->
    `,
  },
  {
    id: "wishlist-page-shared",
    data: "shared_wishlist",
    template: `
      {% assign wishlist = shared_wishlist %}
      {% include "wishlist-page" with wishlist %}
    `,
  },
  {
    id: "wishlist-button-bulk-add-to-cart",
    data: "wishlist",
    events: {
      "click button[data-wk-bulk-add-to-cart]": (event) => {
        WishlistKing.toolkit.requestAddAllToCart(
          event.currentTarget.getAttribute("data-wk-bulk-add-to-cart")
        );
      },
    },
    template: `
      {% assign btn_text = locale.add_all_to_cart %}
      {% assign btn_title = locale.add_all_to_cart %}

      <button type="button" class="wk-button-bulk-add-to-cart" title="{{ btn_title }}" data-wk-bulk-add-to-cart="{{ wishlist.permaId }}">
        <span class="wk-label">{{ btn_text }}</span>
      </button>
    `,
  },
  {
    id: "wishlist-button-clear",
    data: "wishlist",
    events: {
      "click button[data-wk-clear-wishlist]": (event) => {
        WishlistKing.toolkit.clear(
          event.currentTarget.getAttribute("data-wk-clear-wishlist")
        );
      },
    },
    template: `
      {% assign btn_text = locale.clear_wishlist %}
      {% assign btn_title = locale.clear_wishlist %}

      <button type="button" class="wk-button-wishlist-clear" title="{{ btn_title }}" data-wk-clear-wishlist="{{ wishlist.permaId }}">
        <span class="wk-label">{{ btn_text }}</span>
      </button>
    `,
  },
    {
    id: "wishlist-icon-header",
    template: `
<svg xmlns="http://www.w3.org/2000/svg" width="22.093" height="20.227" viewBox="0 0 22.093 20.227"><g transform="translate(-224.718 -45.747)"><path d="M247.608,71.859V62.81l-7.837-4.525-7.837,4.525v9.049l7.837,4.525Z" transform="translate(-6.216 -11.538)" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"></path><g transform="translate(-6.216 -11.538)" fill="#fff" stroke-linecap="round" stroke-linejoin="round"><path d="M 246.2261505126953 76.887939453125 L 245.5391998291016 76.23884582519531 C 245.4459533691406 76.15072631835938 243.2379150390625 74.06102752685547 241.7333831787109 72.34659576416016 C 240.7695007324219 71.24814605712891 240.3019714355469 69.88719940185547 240.4505920410156 68.6126708984375 C 240.5685729980469 67.60106658935547 241.05322265625 66.745361328125 241.8152923583984 66.20317840576172 C 242.3923034667969 65.79220581054688 243.0480804443359 65.57482147216797 243.7113189697266 65.57482147216797 C 244.3044891357422 65.57482147216797 245.2938232421875 65.76116943359375 246.2252349853516 66.79168701171875 C 247.1569061279297 65.76129913330078 248.1461944580078 65.57482147216797 248.7391967773438 65.57482147216797 C 249.4021911621094 65.57482147216797 250.0580291748047 65.79212188720703 250.6357727050781 66.20321655273438 C 251.3973693847656 66.74507141113281 251.8818664550781 67.60035705566406 251.9999389648438 68.61149597167969 C 252.1488037109375 69.88613128662109 251.6815032958984 71.24740600585938 250.7178802490234 72.34632110595703 C 249.2131500244141 74.06095123291016 247.0061645507812 76.15058135986328 246.9129486083984 76.23870086669922 L 246.2261505126953 76.887939453125 Z" stroke="none"></path><path d="M 243.7113189697266 66.57482147216797 C 243.2298278808594 66.57482147216797 242.7747955322266 66.74748992919922 242.3950042724609 67.01799774169922 C 241.1820068359375 67.88099670410156 240.9880065917969 69.98099517822266 242.4850006103516 71.68699645996094 C 243.9759979248047 73.38600158691406 246.2259979248047 75.51200103759766 246.2259979248047 75.51200103759766 C 246.2259979248047 75.51200103759766 248.4750061035156 73.38600158691406 249.9660034179688 71.68699645996094 C 251.4620056152344 69.98099517822266 251.2689971923828 67.88099670410156 250.0559997558594 67.01799774169922 C 249.0090179443359 66.27301025390625 247.3930358886719 66.26997375488281 246.2250061035156 68.572998046875 C 245.4817352294922 67.10621643066406 244.5558776855469 66.57482147216797 243.7113189697266 66.57482147216797 M 243.7113189697266 64.57482147216797 C 244.3283386230469 64.57482147216797 245.2731475830078 64.72216033935547 246.2252960205078 65.43524932861328 C 247.1775512695312 64.72211456298828 248.1221466064453 64.57482147216797 248.739013671875 64.57482147216797 C 249.6113739013672 64.57490539550781 250.4676055908203 64.85624694824219 251.2155151367188 65.388427734375 C 252.2105255126953 66.09632873535156 252.8418884277344 67.19979858398438 252.9931945800781 68.49549865722656 C 253.1748046875 70.05056762695312 252.6195220947266 71.69445037841797 251.4697418212891 73.00563049316406 C 249.9343566894531 74.75521087646484 247.6945037841797 76.8759765625 247.5998992919922 76.96540069580078 C 246.8290405273438 77.69407653808594 245.6233825683594 77.6942138671875 244.8524017333984 76.9656982421875 C 244.7577667236328 76.87626647949219 242.5167999267578 74.75537109375 240.9817657470703 73.00619506835938 C 239.8315887451172 71.69544982910156 239.2759857177734 70.0518798828125 239.4573211669922 68.49684143066406 C 239.6084899902344 67.20060729980469 240.2400207519531 66.09665679931641 241.2355804443359 65.38835906982422 C 241.9825286865234 64.85634613037109 242.8389282226562 64.57482147216797 243.7113189697266 64.57482147216797 Z" stroke="none" fill="#000"></path></g></g></svg>
`,
  },
  {
    id: "wishlist-icon",
    template: `
      <svg class="wk-icon__svg" width="100%" height="100%" viewBox="0 0 64 64" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <path vector-effect="non-scaling-stroke" d="M32.012,59.616c-1.119-.521-2.365-1.141-3.707-1.859a79.264,79.264,0,0,1-11.694-7.614C6.316,42,.266,32.6.254,22.076,0.244,12.358,7.871,4.506,17.232,4.5a16.661,16.661,0,0,1,11.891,4.99l2.837,2.889,2.827-2.9a16.639,16.639,0,0,1,11.874-5.02h0c9.368-.01,17.008,7.815,17.021,17.539,0.015,10.533-6.022,19.96-16.312,28.128a79.314,79.314,0,0,1-11.661,7.63C34.369,58.472,33.127,59.094,32.012,59.616Z"/>
      </svg>
    `,
  },
  {
    id: "remove-icon",
    template: `
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><g transform="translate(-6471.993 -6774.261)"><circle cx="10" cy="10" r="10" transform="translate(6471.993 6774.261)" fill="#cacaca" opacity="0.5"/><line x2="9.974" y2="9.974" transform="translate(6477.006 6779.274)" fill="none" stroke="#fff" stroke-miterlimit="10" stroke-width="1"/><line x1="9.974" y2="9.974" transform="translate(6477.006 6779.274)" fill="none" stroke="#fff" stroke-miterlimit="10" stroke-width="1"/></g></svg>
    `,
  },
  {
    id: "wishlist-share-button-fb",
    data: "wishlist",
    template: `
      <a href="#" class="wk-share-button" title="{{ locale.share_on_facebook }}" data-wk-share-service="facebook" data-wk-share="{{ wishlist.permaId }}">
        <svg version="1.1" x="0px" y="0px" width="100%" height="100%" viewBox="0 0 24 24">
          <path fill="currentColor" d="M18.768,7.465H14.5V5.56c0-0.896,0.594-1.105,1.012-1.105s2.988,0,2.988,0V0.513L14.171,0.5C10.244,0.5,9.5,3.438,9.5,5.32 v2.145h-3v4h3c0,5.212,0,12,0,12h5c0,0,0-6.85,0-12h3.851L18.768,7.465z"/>
        </svg>
      </a>
    `,
  },
  {
    id: "wishlist-share-button-twitter",
    data: "wishlist",
    template: `
      <a href="#" class="wk-share-button" title="{{ locale.share_on_twitter }}" data-wk-share-service="twitter" data-wk-share="{{ wishlist.permaId }}">
        <svg xmlns="http://www.w3.org/2000/svg" width="29.627" height="29.627" viewBox="0 0 29.627 29.627"><g transform="translate(-133.922 -661.121)"><rect width="29.627" height="29.627" rx="4.594" transform="translate(133.922 661.121)" fill="#1d9bf1"/><path d="M157.792,670.987A1.843,1.843,0,0,1,156.1,671c.713-.427.746-.727,1-1.534a6.918,6.918,0,0,1-2.193.839,3.455,3.455,0,0,0-5.974,2.363,3.522,3.522,0,0,0,.089.787,9.8,9.8,0,0,1-7.118-3.609,3.458,3.458,0,0,0,1.068,4.612,3.454,3.454,0,0,1-1.563-.432c0,.014,0,.028,0,.043a3.456,3.456,0,0,0,2.771,3.387,3.467,3.467,0,0,1-1.56.06,3.459,3.459,0,0,0,3.226,2.4,6.946,6.946,0,0,1-5.113,1.43,9.823,9.823,0,0,0,15.12-8.276c0-.15,0-.3-.009-.447A7.372,7.372,0,0,0,157.792,670.987Z" fill="#fff"/></g></svg>
      </a>
    `,
  },
  {
    id: "wishlist-share-button-whatsapp",
    data: "wishlist",
    template: `
      <a href="#" class="wk-share-button" title="{{ locale.share_with_whatsapp }}" data-wk-share-service="whatsapp" data-wk-share="{{ wishlist.permaId }}">
        <svg xmlns="https://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24">
          <path fill="currentColor" stroke="none" d="M20.1,3.9C17.9,1.7,15,0.5,12,0.5C5.8,0.5,0.7,5.6,0.7,11.9c0,2,0.5,3.9,1.5,5.6l-1.6,5.9l6-1.6c1.6,0.9,3.5,1.3,5.4,1.3l0,0l0,0c6.3,0,11.4-5.1,11.4-11.4C23.3,8.9,22.2,6,20.1,3.9z M12,21.4L12,21.4c-1.7,0-3.3-0.5-4.8-1.3l-0.4-0.2l-3.5,1l1-3.4L4,17c-1-1.5-1.4-3.2-1.4-5.1c0-5.2,4.2-9.4,9.4-9.4c2.5,0,4.9,1,6.7,2.8c1.8,1.8,2.8,4.2,2.8,6.7C21.4,17.2,17.2,21.4,12,21.4z M17.1,14.3c-0.3-0.1-1.7-0.9-1.9-1c-0.3-0.1-0.5-0.1-0.7,0.1c-0.2,0.3-0.8,1-0.9,1.1c-0.2,0.2-0.3,0.2-0.6,0.1c-0.3-0.1-1.2-0.5-2.3-1.4c-0.9-0.8-1.4-1.7-1.6-2c-0.2-0.3,0-0.5,0.1-0.6s0.3-0.3,0.4-0.5c0.2-0.1,0.3-0.3,0.4-0.5c0.1-0.2,0-0.4,0-0.5c0-0.1-0.7-1.5-1-2.1C8.9,6.6,8.6,6.7,8.5,6.7c-0.2,0-0.4,0-0.6,0S7.5,6.8,7.2,7c-0.3,0.3-1,1-1,2.4s1,2.8,1.1,3c0.1,0.2,2,3.1,4.9,4.3c0.7,0.3,1.2,0.5,1.6,0.6c0.7,0.2,1.3,0.2,1.8,0.1c0.6-0.1,1.7-0.7,1.9-1.3c0.2-0.7,0.2-1.2,0.2-1.3C17.6,14.5,17.4,14.4,17.1,14.3z"/>
        </svg>
      </a>
    `,
  },
  {
    id: "wishlist-share-button-email",
    data: "wishlist",
    template: `
      <a href="#" class="wk-share-button" title="{{ locale.share_by_email }}" data-wk-share-service="email" data-wk-share="{{ wishlist.permaId }}">
        <svg xmlns="http://www.w3.org/2000/svg" width="29.627" height="29.627" viewBox="0 0 29.627 29.627"><g transform="translate(-211.451 -661.121)"><rect width="29.627" height="29.627" rx="4.594" transform="translate(211.451 661.121)" fill="#ffb200"/><rect width="16.615" height="11.525" transform="translate(217.957 670.029)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.7"/><path d="M234.44,670.276l-8.049,6.452-8.3-6.7" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.7"/></g></svg>
      </a>
    `,
  },
  {
    id: "wishlist-share-button-link",
    data: "wishlist",
    template: `
      <a href="#" class="wk-share-button" title="{{ locale.get_link }}" data-wk-share-service="link" data-wk-share="{{ wishlist.permaId }}">
        <svg xmlns='https://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 512 512'>
          <path fill="currentColor" d='M459.654,233.373l-90.531,90.5c-49.969,50-131.031,50-181,0c-7.875-7.844-14.031-16.688-19.438-25.813
            l42.063-42.063c2-2.016,4.469-3.172,6.828-4.531c2.906,9.938,7.984,19.344,15.797,27.156c24.953,24.969,65.563,24.938,90.5,0
            l90.5-90.5c24.969-24.969,24.969-65.563,0-90.516c-24.938-24.953-65.531-24.953-90.5,0l-32.188,32.219
            c-26.109-10.172-54.25-12.906-81.641-8.891l68.578-68.578c50-49.984,131.031-49.984,181.031,0
            C509.623,102.342,509.623,183.389,459.654,233.373z M220.326,382.186l-32.203,32.219c-24.953,24.938-65.563,24.938-90.516,0
            c-24.953-24.969-24.953-65.563,0-90.531l90.516-90.5c24.969-24.969,65.547-24.969,90.5,0c7.797,7.797,12.875,17.203,15.813,27.125
            c2.375-1.375,4.813-2.5,6.813-4.5l42.063-42.047c-5.375-9.156-11.563-17.969-19.438-25.828c-49.969-49.984-131.031-49.984-181.016,0
            l-90.5,90.5c-49.984,50-49.984,131.031,0,181.031c49.984,49.969,131.031,49.969,181.016,0l68.594-68.594
            C274.561,395.092,246.42,392.342,220.326,382.186z'/>
        </svg>
      </a>
    `,
  },
  {
    id: "wishlist-share-button-contact",
    data: "wishlist",
    template: `
      <a href="#" class="wk-share-button" title="{{ locale.send_to_customer_service }}" data-wk-share-service="contact" data-wk-share="{{ wishlist.permaId }}">
        <svg width="100%" height="100%" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path fill="currentColor" d="M19 2H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h4l3 3 3-3h4c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-6 16h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 11.9 13 12.5 13 14h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z"/>
        </svg>
      </a>
    `,
  },
];

export default templates;
